import { Select, Table, Tag } from 'antd';
import useSummaryCurrentProject from './useSummaryCurrentProject';
import { useEffect, useState } from 'react';
import { useAuth } from '../../../hooks/useAuth';
import Loading from '../../../components/loading/Loading';
import { Tooltip } from 'react-tooltip';
import EmptyProject from './EmptyProject';
import { AiOutlineDownload } from 'react-icons/ai';
import { toast } from 'react-toastify';
import axiosInstance from '../../../services/axios-client';
import { useParams } from 'react-router-dom';
import ActionButtonGradient from '../../../components/button/ActionButtonGradient';

const SummaryCurrentProject = () => {
    const {
        summary,
        columns,
        getSummary,
        project,
        getProject,
        userSummary,
        setUser,
        optionFilterRow,
        filteredRow,
        setFilteredRow,
        calibratorFilter
    } = useSummaryCurrentProject()
    const {
        getCurrentUser
    } = useAuth()

    const params = useParams()
    const [isLoading, setIsLoading] = useState(false)
    const [isDownloading, setIsDownloading] = useState(false)
    const [paramApiCall, setParamApiCall] = useState([])

    // Reset filters when project changes
    useEffect(() => {
        setFilteredRow([]);
        setParamApiCall([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params.project_id]);

    useEffect(() => {
        const loadData = async () => {
            setIsLoading(true);
            let user = getCurrentUser();
            setUser(user);
    
            if (user.ID && params.project_id) {
                // Wait for both getProject and getSummary to finish
                await Promise.all([
                    getProject(params.project_id),
                    getSummary(user.ID, params.project_id, paramApiCall)
                ]);
            }
    
            // Once both async operations are done, stop loading
            setIsLoading(false);
        };
    
        loadData();
    }, 
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [params.project_id, paramApiCall]);

    const downloadExcelFile = async (path) => {
        try {
            setIsDownloading(true);
            const response = await axiosInstance.get(`${path}`, {
                responseType: 'arraybuffer',
            });
        
            // Create a Blob from the response data
            const blob = new Blob([response.data], { type: response.headers['content-type'] });
        
            // Create a temporary link element
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
        
            // Set the download attribute and trigger a click to simulate the download
            link.download = 'report.xlsx'; // Set the desired file name
            link.click();
        
            // Clean up: Remove the temporary link
            window.URL.revokeObjectURL(link.href);
        } catch (error) {
            if(error.response){
                toast.error(error?.response?.data?.status?.description)
            } else if(error.message) {
                toast.error(error.message)
            } else{
                toast.error(error)
            }
        } finally {
            setIsDownloading(false);
        }
    }

    // console.log("option row",optionFilterRow)
    // console.log("DATA UPDATED TERAKHIR", summary)

    const downloadReportFileExcel = (calibratorId, projectID) => {
        return `/auth/projects-report-summary?calibratorID=${calibratorId}&projectID=${projectID}`
    }

    return(
        <div className="container-fluid justify-content-center">
            <style>
                {`
                    .modern-select .ant-select-selector {
                        border: 1px solid #d9d9d9 !important;
                        border-radius: 8px !important;
                        padding: 4px 8px !important;
                        box-shadow: none !important;
                        transition: border-color 0.3s ease, box-shadow 0.3s ease !important;
                    }
                    .modern-select .ant-select-selector:hover {
                        border-color: #02B4CC !important;
                    }
                    .modern-select.ant-select-focused .ant-select-selector {
                        border-color: #02B4CC !important;
                        box-shadow: 0 0 0 2px rgba(2, 180, 204, 0.1) !important;
                    }
                    .spinner {
                        border: 2px solid transparent;
                        border-top: 2px solid #ffffff;
                        border-radius: 50%;
                        width: 12px;
                        height: 12px;
                        animation: spin 1s linear infinite;
                    }
                    @keyframes spin {
                        0% { transform: rotate(0deg); }
                        100% { transform: rotate(360deg); }
                    }
                `}
            </style>
            <Loading state={isLoading}/>
            {
                summary ? (
                    summary.length > 0 ?
                    <>
                        <div className="d-flex align-items-center justify-content-between mb-4">
                            <h3 style={{ margin: 0, fontWeight: 600, color: '#1a1a1a' }}>
                                {project?.Name} - {project?.Year}
                            </h3>
                            <div className="d-flex align-items-center gap-3">
                                <Select
                                    className="modern-select"
                                    mode="multiple"
                                    allowClear
                                    showSearch
                                    size="large"
                                    placeholder="Filter by Business Unit"
                                    style={{
                                        width: '300px',
                                        minWidth: '250px'
                                    }}
                                    options={optionFilterRow}
                                    onChange={(e, optionObjects) => {
                                        let finalValue = []
                                        optionObjects.forEach((selectedValue) => {
                                            // console.log(selectedValue.type, selectedValue.value)
                                            if (selectedValue.type === "BU") {
                                                let data = calibratorFilter.filter((obj) => obj.type === "User" && obj.bu_id === selectedValue.value).map(obj => obj.value);
                                                finalValue = [...finalValue, ...data]
                                            }
                                        })
                                        // console.log("final value",finalValue)
                                        setParamApiCall(finalValue) 
                                        // console.log("gatau e apaan",e)
                                        setFilteredRow(e)  
                                    }}
                                    value={filteredRow}
                                    maxTagCount={0}
                                    optionFilterProp="label"
                                    filterOption={(input, option) =>
                                        (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                                    }
                                />
                                <ActionButtonGradient
                                    onClick={() => downloadExcelFile(downloadReportFileExcel(userSummary.ID, params.project_id))}
                                    variant='primary'
                                    children={isDownloading ? (
                                        <div style={{ display: 'flex', gap: '8px' }}>
                                            <div className="spinner" /> Downloading...
                                        </div>
                                        ) : (
                                        <>
                                            <AiOutlineDownload style={{ fontSize: '12px' }} /> Download Report
                                        </>
                                    )}
                                    disabled={isDownloading}
                                />
                            </div>
                        </div>
                        <Table 
                            // rowClassName='custom-table-row'
                            key={Math.random()}
                            rowClassName={(record, _) => record.position === "last-1"|| record.position === "last" ? 'custom-table-row-green' : (record.position === "totalbu" ? 'custom-table-row-total' : (record.position === "totalbu-1" ? 'custom-table-row-gray' : 'custom-table-row'))}
                            columns={columns} 
                            dataSource={summary} 
                            scroll={{ x: 900}} 
                            pagination={false} 
                        />
                        <Tooltip
                            id="tooltip-status"
                            style={{ 
                                backgroundColor: "#efefef", 
                                color: "#222", 
                                width: "20rem"
                            }}
                        >
                            <b>Calibration Status</b>
                            <div className="mb-1">
                                <Tag 
                                    color={'yellow'}
                                    data-tooltip-id="tooltip-status"
                                >
                                    Waiting
                                </Tag>: Waiting calibration from the previous phase
                            </div>
                            <div className="mb-1">
                                <Tag 
                                    color={'blue'}
                                    data-tooltip-id="tooltip-status"
                                >
                                    Calibrate
                                </Tag>: You can start to calibrate user
                            </div>
                            <div className="mb-1">
                                <Tag 
                                    color={'green'}
                                    data-tooltip-id="tooltip-status"
                                >
                                    Complete
                                </Tag>: Calibration already submitted
                            </div>
                        </Tooltip>
                    </>:
                    <EmptyProject/>
                )
                :
                <Loading/>
            }
        </div>
    )
}

export default SummaryCurrentProject